import React from 'react';

/**
 * Agent Noda brand mark + wordmark, rendered from the official asset
 * under `public/brand/`. Replaces the hand-coded ring SVG that was
 * standing in for the approved brand. The asset already contains the
 * wordmark, so no inline `<span>Agent Noda</span>` is needed.
 *
 * Sized to fit the parent via `className` — e.g. `h-6` on the landing
 * hero. The SVG's intrinsic aspect ratio (~3.6:1) keeps the width
 * proportional when only height is set.
 *
 * The asset is on the brand's painted black plate. That sits cleanly on
 * the dark surfaces the app uses everywhere (PageShell). If a
 * light-surface variant is needed later, ship a second asset rather
 * than tinting at render time.
 */
const Logo = ({ className = '' }) => {
  return (
    <img
      src={`${process.env.PUBLIC_URL ?? ''}/brand/agent-noda-logo.svg`}
      alt="Agent Noda"
      className={className}
    />
  );
};

export default Logo;
